exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-zoom[data-v-c7cb7c10]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:4;background:#fff}.media-zoom__close[data-v-c7cb7c10]{position:absolute;right:0;top:0;z-index:1}\n", ""]);

// exports
